import SegmentedControl from "app/components/SegmentedControl/SegmentedControl";
import { ReportTypes } from "app/utils/const";
import React from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

type Props = {
  tab: string;
  getTabs: any;
  isReportListLoading: boolean;
};

const MobileReportSummary: React.FC<Props> = ({
  tab,
  getTabs,
  isReportListLoading,
}) => {
  return (
    <div className={`report-controls ${tab}`}>
      <div className="report-controls-wrapper">
        <div className="report-controls__buttons">
          <SegmentedControl
            tabs={getTabs}
            tabTypes={ReportTypes}
            disableFilterTab={isReportListLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default MobileReportSummary;
